import {  INews } from './INews';
import { newsProperties } from './mapperConfig';
import { UtilityService } from '../../../infrastructure/services/utils';

/**
 * provide transformation functionality for news data using mapper configuration
 * @param   {Object} newsItem transformed object
 */
export class NewsMapper {
  newsItem: INews = {};

  constructor(newsProperty: [] = []) {
    this.newsItem = UtilityService.getMappedProperties(
      newsProperty,
      newsProperties,
      this.newsItem
    );
  }
}
